import { getKeypairsInfo } from '@/cli/balance'
import {
  IDENTITY_KEY_PATH,
  LOG_PATH,
  TESTNET_KNOWN_VALIDATORS,
  TESTNET_VALIDATOR_KEY_PATH,
  TESTNET_VALIDATOR_VOTE_KEY_PATH,
} from '@/config/constants'
import { DefaultConfigType } from '@/config/types'

export const startBamTestnetScript = (
  commissionBps = 10000,
  relayerUrl: string,
  blockEngineUrl: string,
  shredReceiverAddr: string,
  bamUrl: string,
  config: DefaultConfigType,
  solanaCLI = 'agave-validator',
) => {
  const { validatorKeyAddress } = getKeypairsInfo(config)

  const xdpEnabled = config.XDP
  const zeroCopyEnabled = config.ZERO_COPY
  // const jagSnapshotsEnabled = config.JAG_SNAPSHOTS
  const xdpFlags = xdpEnabled
    ? [
        `--experimental-retransmit-xdp-cpu-cores 1 \\`,
        `--experimental-poh-pinned-cpu-core 10 \\`,
      ].join('\n')
    : ''
  const zeroCopyFlag = zeroCopyEnabled
    ? [`--experimental-retransmit-xdp-zero-copy \\`].join('\n')
    : ''

  const knownValidators = TESTNET_KNOWN_VALIDATORS

  const filteredValidators = knownValidators.filter(
    (address) => address !== validatorKeyAddress,
  )

  const validatorArgs = filteredValidators
    .map((address) => `--known-validator ${address} \\`)
    .join('\n')

  const script = `#!/bin/bash
exec ${solanaCLI} \\
--identity ${IDENTITY_KEY_PATH} \\
--vote-account ${TESTNET_VALIDATOR_VOTE_KEY_PATH} \\
--authorized-voter  ${TESTNET_VALIDATOR_KEY_PATH} \\
--log ${LOG_PATH} \\
--accounts ${config.ACCOUNTS_PATH} \\
--ledger ${config.LEDGER_PATH} \\
--snapshots ${config.SNAPSHOTS_PATH} \\
--entrypoint entrypoint.testnet.solana.com:8001 \\
--entrypoint entrypoint2.testnet.solana.com:8001 \\
--entrypoint entrypoint3.testnet.solana.com:8001 \\
${validatorArgs}
--tip-payment-program-pubkey GJHtFqM9agxPmkeKjHny6qiRKrXZALvvFGiKf11QE7hy \\
--tip-distribution-program-pubkey F2Zu7QZiTYUhPd7u9ukRVwxh7B71oA3NMJcHuCHc29P2 \\
--merkle-root-upload-authority 8F4jGUmxF36vQ6yabnsxX6AQVXdKBhs8kGSUuRKSg8Xt \\
--commission-bps ${commissionBps} \\
--rpc-bind-address 0.0.0.0 \\
--block-engine-url ${blockEngineUrl} \\
--shred-receiver-address ${shredReceiverAddr} \\
--bam-url ${bamUrl} \\
--dynamic-port-range 8000-8026 \\
--rpc-port 8899 \\
--wal-recovery-mode skip_any_corrupted_record \\
--limit-ledger-size 50000000 \\
--block-production-method central-scheduler-greedy \\
--block-verification-method unified-scheduler \\
--maximum-full-snapshots-to-retain 1 \\
--maximum-incremental-snapshots-to-retain 2 \\
--expected-shred-version 1516 \\
--wait-for-supermajority 415524281 \\
--expected-bank-hash 14Ev1zNXpm95UHYYbACwao8Xt4W9ziQ2PVL64iusnGg1 \\
--expected-genesis-hash 4uhcVJyU9pJkvQyS88uRDiswHXSCkY3zQawwpjk2NsNY \\
${xdpFlags}
${zeroCopyFlag}
`
  // To be added later for XDP
  // --experimental-retransmit-xdp-cpu-cores 2 \\
  // --experimental-retransmit-xdp-zero-copy \\
  // --experimental-poh-pinned-cpu-core 6 \\
  // adding code
  return script
}
